export default __webpack_public_path__ + "static/media/r200.793d71fa.png";